import { ManagerResource } from '~/modules/manager/resource/manager-resource.model';
import type { TApiHttpClientRequestConfig } from '~/misc/resource/types';
import type {
  TManagerAppointmentType,
  TManagerAppointmentTypeUpdatePayload,
} from '~/modules/manager/types';

export class ManagerAppointmentTypesModel extends ManagerResource {
  list(
    companyId: string | number,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TManagerAppointmentType[]> {
    return this.get<TManagerAppointmentType[]>(
      `companies/${companyId}/appointment_types`,
      undefined,
      requestConfig
    );
  }

  update(
    appointmentTypeId: string | number,
    payload: TManagerAppointmentTypeUpdatePayload,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TManagerAppointmentType> {
    return this.patch<TManagerAppointmentType>(
      `appointment_types/${appointmentTypeId}`,
      payload,
      requestConfig
    );
  }
}
